import { useCallback } from "react";

import { use2FAState } from "Login/TwoFA/API/queryHooks";
import { useTwoFAContext } from "Login/TwoFA/TwoFA";
import { useSecondFactorIcon } from "Login/TwoFA/stateHooks";

import AuthCodeInput from "../../AuthCodeInput";

const SecondFactorCode = () => {
  const { secondCode, setSecondCode, onInputChange } = useTwoFAContext();
  const [{ secondFactorType, maskedSecondFactor }] = use2FAState();
  const secondFactorIcon = useSecondFactorIcon();

  const setCode = useCallback(
    (value) => {
      setSecondCode(value);
      if (typeof onInputChange === "function") onInputChange(value);
    },
    [onInputChange, setSecondCode]
  );

  return (
    <AuthCodeInput
      data-cy="TwoFA_SecondFactorCode"
      code={secondCode}
      setCode={setCode}
      allowPassword={false}
      factorType={secondFactorType}
      factorDisplay={maskedSecondFactor}
      factorIcon={secondFactorIcon}
    />
  );
};

export default SecondFactorCode;
